
const modules = {
  general: {
    title: 'General',
    icon: 'mdi-view-dashboard',
    items: [
      {
        icon: 'mdi-view-dashboard-variant',
        link: '/dashboard-master',
        text: 'Dashboard Ejecutivo',
        code: 'dashboard_maestro'
      },
      {
        icon: 'mdi-monitor-dashboard',
        link: '/dashboard',
        text: 'Dashboard Operativo',
        code: 'dashboard_general'
      },
    ],
  },
  blackList: {
    title: 'Lista Negra SAT',
    icon: 'mdi-invoice-list',
    items: [
      {
        icon: 'mdi-monitor-dashboard',
        link: '/black-list/dashboard',
        text: 'Dashboard',
        code: 'dashboard_listas_negras'
      },
      {
        icon: 'mdi-magnify',
        link: '/black-list/rfc-search',
        text: 'Búsqueda Individual',
        code: 'busqueda_individual'
      },
      {
        icon: 'mdi-card-search',
        link: '/black-list/massive-rfc-search',
        text: 'Búsqueda Masiva',
        code: 'busqueda_masiva'
      },
      {
        icon: 'mdi-qrcode-scan',
        link: '/black-list/invoices',
        text: 'CFDIs',
        code: 'cfdis'
      },
    ],
  },
  payroll: {
    title: 'Nómina',
    icon: 'mdi-account-credit-card',
    items: [
      {
        icon: 'mdi-monitor-dashboard',
        link: '/payroll/dashboard',
        text: 'Dashboard',
        code: 'dashboard_nomina'
      },
      {
        icon: 'mdi-scale-balance',
        link: '/payroll/confronta',
        text: 'Confronta',
        code: 'confronta_nomina'
      },
      {
        icon: 'mdi-folder-information-outline',
        link: '/payroll/not-stamped-invoices',
        text: 'No Timbrados',
        code: 'no_timbrados'
      },
      {
        icon: 'mdi-file-document-multiple-outline',
        link: '/payroll/adjustments',
        text: 'Pólizas de Ajuste',
        code: 'poliza_ajuste'
      },
      { icon: 'mdi-qrcode-scan',
        link: '/payroll/invoices',
        text: 'CFDIs Descargados',
        code: 'cfdis_descargados_nomina'
      },
    ],
  },
  satVault: {
    title: 'Bóveda SAT',
    icon: 'mdi-warehouse',
    items: [
      {
        icon: 'mdi-briefcase-download-outline',
        link: '/sat-vault/download',
        text: 'Descarga de CFDIs',
        code: 'descarga_cfdis'
      },
      {
        icon: 'mdi-progress-download',
        link: '/sat-vault/automatic-download',
        text: 'Descarga Automatizada',
        code: 'descarga_automatizada'
      },
      {
        icon: 'mdi-qrcode-scan',
        link: '/sat-vault/invoices',
        text: 'CFDIs Descargados',
        code: 'cfdi_relacionados'
      },
      {
        icon: 'mdi-file-tree-outline',
        link: '/sat-vault/invoices-relations',
        text: 'CFDIs Relacionados',
        code: 'cfdi_descargados'
      },
      {
        icon: 'mdi-file-clock-outline',
        link: '/sat-vault/download-history',
        text: 'Historial Descargas',
        code: 'historial_descargas'
      },
      {
        icon: 'mdi-microsoft-excel',
        link: '/sat-vault/report-provider',
        text: 'Reporte Proveedores',
        code: 'reporte_proveedores'
      },
    ],
  },
  incomeAndExpenditure: {
    title: 'Emitidos y Recibidos',
    icon: 'mdi-swap-horizontal',
    items: [
      {
        icon: 'mdi-scale-balance',
        link: '/emitted-and-received/confronta',
        text: 'Confronta',
        code: 'confronta_emitidos_recibidos'
      },
      {
        icon: 'mdi-scale-balance',
        link: '/emitted-and-received/reception',
        text: 'Recepción de Pagos',
        code: 'recepcion_pagos'
      },
    ],
  },
  manualLoad: {
    title: 'Bóveda ERP',
    icon: 'mdi-archive-settings',
    items: [
      {
        icon: 'mdi-file-upload-outline',
        link: '/manual-load/load-xmls',
        text: 'Carga XMLs',
        code:'cargar_xmls'
      },
      {
        icon: 'mdi-folder-upload-outline',
        link: '/manual-load/load-csv',
        text: 'Carga Lista de Raya',
        code: 'cargar_lista_raya'
      },
      {
        icon: 'mdi-file-settings-outline',
        link: '/manual-load/admin-load-xmls',
        text: 'CFDIs Cargados',
        code: 'cfdis_cargados'
      },
      {
        icon: 'mdi-folder-settings-outline',
        link: '/manual-load/admin-load-csvs',
        text: 'Administrar Listas de Raya',
        code: 'administrar_lista_raya'
      },
    ],
  },
  analytics: {
    title: 'Analítica',
    icon: 'mdi-google-analytics',
    items: [
      {
        icon: 'mdi-monitor-dashboard',
        link: '/analytics/dashboard',
        text: 'Dashboard',
        code: 'dashboard_analitica'
      },
      {
        icon: 'mdi-cash-plus',
        link: '/analytics/sells',
        text: 'Ventas',
        code: 'ventas'
      },
      {
        icon: 'mdi-cash-minus',
        link: '/analytics/costs',
        text: 'Costos / Gastos',
        code: 'costos_gastos'
      },
      {
        icon: 'mdi-file-chart-outline',
        link: '/analytics/anual-report',
        text: 'Informe Anual',
        code: 'informe_anual'
      },
      {
        icon: 'mdi-currency-usd-off',
        link: '/analytics/retentions',
        text: 'Retenciones',
        code: 'retenciones'
      },
      {
        icon: 'mdi-scale-balance',
        link: '/analytics/confronta',
        text: 'Confronta',
        code: 'confronta_analitica'
      },
    ],
  },
  billing: {
    title: 'Facturación',
    icon: 'mdi-cash-register',
    items:[
      // {icon: 'mdi-badge-account-horizontal', link: '', text: 'Administración',
      //   items:[
      //     {icon: 'mdi-certificate-outline', link: '/billing/administration/certificates', text: 'Certificados ', },
      //     {icon: 'mdi-archive-outline', link: '/billing/administration/products', text: 'Productos', },
      //     {icon: 'mdi-face-agent', link: '/billing/administration/clients', text: 'Clientes', },
      //     {icon: 'mdi-view-list-outline', link: '/billing/administration/series', text: 'Series', },
      //   ],
      //   code: 'administracion'
      // },
      {icon: 'mdi-network-pos', link: '/billing/panel', text: 'Panel de Administración', code: 'panel_facturacion' },
    ]
  },
  chatGPT: {
    title: 'Agente IA',
    icon: 'mdi-robot',
    items: [
      {
        icon: 'mdi-robot',
        link: '/chat-gpt',
        text: 'Conversación',
        code: 'conversacion'
      },
    ],
  },
  sanfer: {
    title: 'Conciliación',
    icon: 'mdi-cog',
    items: [
      {
        icon: 'mdi-file-document-outline',
        link: '/account-status',
        text: 'Edo. de Cuenta',
        code: 'account_status'
      },
    ],
  },
}

export default modules;
